import { render, staticRenderFns } from "./FinancialStatistics.vue?vue&type=template&id=59516612"
import script from "./FinancialStatistics.vue?vue&type=script&lang=js"
export * from "./FinancialStatistics.vue?vue&type=script&lang=js"
import style0 from "./FinancialStatistics.vue?vue&type=style&index=0&id=59516612&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports